import React, { useEffect, useState } from "react";

import {
  Box,
  Typography,
  TextField,
  Grid,
  CircularProgress,
  Button,
  Paper,
  Tabs,
  Tab,
  // InputLabel,
  // Select,
  // MenuItem,
  // FormControl,
} from "@mui/material";
import TabPanel from "../../component/TabPanel";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import { getVendorById, updateVendor, deleteVendor } from "../../api/vendor";
import { handleAxiosError } from "../../config/action-config";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-material.css";
import { AgGridReact } from "ag-grid-react";
import {
  customerProjectsTable,
  CustomerticketsTable,
  ticketsTable,
  vendorPurchaseTable,
} from "../../config/grid-columns-defs";
import { showAlert } from "../../actions/alert";
import { getCustomerById, updateCustomer } from "../../api/customer";
import {
  deleteSubCustomers,
  getSubCustomersById,
  updateSubCustomers,
} from "../../api/subCustomers";

const deleteApis = {
  CUSTOMER: deleteSubCustomers,
  // 'TASK': deleteTask,
  // 'EMPLOYEE': deleteEmployee,
};

const emptyCustomerData = {
  email: "",
  firstname: "",
  lastname: "",
  user_id: "",
  id: "",
  address: "",
  contact: "",
  creation_date: "",
};

export default function SubCustomerView() {
  const rowHeight = 38;

  const user = useSelector((state) => state.user);
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [customerData, setCustomerData] = useState(emptyCustomerData);
  const [projects, setProjects] = useState([]);
  const [tickets, setTickets] = useState([]);

  const [tabIndex, setTabIndex] = useState(0);

  const [deletingContent, setDeletingContent] = useState({ table: "", row: 0 });
  const [editDisabled, setEditDisabled] = useState(true);
  const onCustomerDataUpdate = () => {
    updateSubCustomers(
      customerData.id,
      getUpdatableCustomerData(customerData),
      user.token
    )
      .then((res) => {
        loadMasterData();
        dispatch(showAlert(res.data.msg));
        setEditDisabled(true);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  const loadMasterData = () => {
    getSubCustomersById(params.id, user.token)
      .then((res) => {
        setCustomerData(res.data.data.subcustomer);
        // setProjects(res.data.data.projects);
        setTickets(res.data.data.tickets);
        setLoading(false);
      })
      .catch((err) => {
        handleAxiosError(err, dispatch);
      });
  };

  useEffect(() => {
    if (!params.id) {
    } else loadMasterData();
  }, [params.id]);

  const changeUpdateData = (e) => {
    setCustomerData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const onDelete = () => {
    const deleteApi = deleteApis[deletingContent.table];
    deleteApi(deletingContent.row, user.token)
      .then((res) => {
        dispatch(showAlert(res.data.msg));
        setDeletingContent({ type: "", row: 0 });
        if (deletingContent.table === "CUSTOMER") {
          navigate("/subcustomer");
        }
        // else if (deletingContent.table === 'EMPLOYEE') { loadMasterData(); }
        // else if (deletingContent.table == 'TASK') { loadTimesheetData(); }
      })
      .catch((err) => {
        setDeletingContent({ table: "", row: 0 });
        handleAxiosError(err, dispatch);
      });
  };

  return loading ? (
    <Loading />
  ) : (
    <Box className="pmt-container-box">
      <Paper className="pmt-title-box" sx={{ padding: "20px" }}>
        <Box
          className="typography-title"
          sx={{ justifyContent: "space-between" }}
        >
          <Typography variant="h6">Sub User Details</Typography>
          <Box sx={{ display: "flex", columnGap: 1 }}>
            <Button
              variant="contained"
              onClick={() => {
                setEditDisabled((prev) => !prev);
              }}
              style={{ padding: "5px 7px" }}
              className="cancel-button"
            >
              {editDisabled ? "Edit" : "Cancel"}
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setDeletingContent({ table: "CUSTOMER", row: customerData.id });
              }}
              className="blue-button"
            >
              Delete
            </Button>
          </Box>
        </Box>
        <Grid container columnSpacing={2} rowSpacing={1} sx={{ pt: "1rem" }}>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              size="small"
              margin="dense"
              name="firstname"
              fullWidth
              value={customerData.firstname}
              onChange={changeUpdateData}
              label="First name"
              type="text"
              variant="outlined"
              disabled={editDisabled}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              size="small"
              margin="dense"
              name="lastname"
              fullWidth
              value={customerData.lastname}
              onChange={changeUpdateData}
              label="Last name"
              type="text"
              variant="outlined"
              disabled={editDisabled}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              size="small"
              margin="dense"
              name="email"
              fullWidth
              value={customerData.email}
              onChange={changeUpdateData}
              label="Email"
              type="text"
              variant="outlined"
              disabled
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              size="small"
              margin="dense"
              name="contact"
              fullWidth
              value={customerData.contact}
              error={!/^[0-9]{10}$/.test(customerData.contact)}
              inputProps={{ maxLength: 10 }}
              onChange={changeUpdateData}
              label="Contact"
              type="text"
              variant="outlined"
              disabled={editDisabled}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={4}>
            <TextField
              size="small"
              margin="dense"
              name="creation_date"
              fullWidth
              value={formatDate(customerData.creation_date)}
              onChange={changeUpdateData}
              label="Creation Date"
              type="text"
              variant="outlined"
              disabled={true}
            />
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            {/* <TextField
              size="small"
              margin="dense"
              name="id"
              fullWidth
              value={customerData.id}
              onChange={changeUpdateData}
              label="User Id"
              type="text"
              variant="outlined"
              disabled={true}
            /> */}
          </Grid>
          <Grid item xs={12} md={6} lg={4}>
            <TextField
              size="small"
              margin="dense"
              name="address"
              fullWidth
              value={customerData.address}
              onChange={changeUpdateData}
              label="Address"
              type="text"
              variant="outlined"
              disabled={editDisabled}
            />
          </Grid>

          <Grid item xs={12} md={6} lg={8} xl={6}>
            {editDisabled ? (
              <></>
            ) : (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "right",
                  columnGap: 1,
                  ml: "auto",
                }}
              >
                <Button
                  className="blue-button"
                  variant="contained"
                  onClick={onCustomerDataUpdate}
                  style={{ padding: "5px 7px" }}
                >
                  Update
                </Button>
              </Box>
            )}
          </Grid>
        </Grid>
      </Paper>
      <br />

      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={tabIndex}
          onChange={(e, nv) => {
            setTabIndex(nv);
          }}
          aria-label="basic tabs example"
        >
          <Tab
            label="Tickets"
            id="simple-tab-0"
            aria-controls="simple-tabpanel-0"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          />
        </Tabs>
      </Box>
      <TabPanel value={tabIndex} index={0}>
        <Paper>
          {/* <Box sx={{ display: 'flex', columnGap: 1, p: 2, borderBottom: 1 }}>
                            <Button variant='contained' style={{ padding: '5px 7px' }} onClick={onAddProjectClick} >Assign Project</Button>
                            {
                                Boolean(selectedProjectRow) ? <Button variant='contained' style={{ padding: '5px 7px' }}
                                    onClick={() => { setDeletingContent({ table: "PROJECT", row: selectedProjectRow }) }}
                                >Delete Selected</Button> : <></>
                            }
                        </Box> */}
          <div className="ag-theme-material pmt-controll-table">
            <AgGridReact
              columnDefs={CustomerticketsTable}
              rowData={tickets}
              headerHeight="38"
              rowHeight={rowHeight}
              domLayout="autoHeight"
              defaultColDef={{
                resizable: true,
                flex: 1,
              }}
              // rowSelection="single"
              // onRowClicked={(params) => { setSelectedProjectRow(params.data.ep_id) }}
            />
          </div>
        </Paper>
      </TabPanel>

      <DeleteDialog
        deletingContent={deletingContent}
        setDeletingContent={setDeletingContent}
        onDelete={onDelete}
      />
    </Box>
  );
}

function DeleteDialog({ deletingContent, setDeletingContent, onDelete }) {
  return (
    <Dialog
      open={Boolean(deletingContent.table)}
      onClose={() => {
        setDeletingContent({ table: "", row: 0 });
      }}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Confirm Delete</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          This will delete the row in table {deletingContent.table} with id:{" "}
          {deletingContent.row}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            setDeletingContent({ table: "", row: 0 });
          }}
          className="cancel-button"
        >
          Cancel
        </Button>
        <Button onClick={onDelete} className="blue-button" autoFocus>
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function formatDate(date) {
  if (!date) return "Not Provided";
  let d = new Date(date);
  return `${d.getDate()}/${d.getMonth() + 1}/${d.getFullYear()}`;
}

function Loading() {
  return (
    <div className="page d-flex">
      <div className="m-auto text-center">
        <CircularProgress />
      </div>
    </div>
  );
}

function getUpdatableCustomerData(data) {
  return {
    email: data.email,
    firstname: data.firstname,
    lastname: data.lastname,
    address: data.address,
    contact: data.contact,
  };
}
